import { useLocation } from 'react-router';

export const useIsOnsiteArea = () => {
  const { pathname } = useLocation();
  return pathname.includes('onsite');
};
